import type { ReactNode } from 'react'
import * as React from 'react'
import useOfferPageWalledGarden from 'hooks/OfferPage/useOfferPageWalledGarden'

interface Props {
  wall?: ReactNode
  bypassWall?: boolean
  children?: React.ReactNode
}

function SoftOfferPageWalledGarden({
  wall,
  bypassWall,
  children,
}: Props) {
  const showWall = useOfferPageWalledGarden(bypassWall)

  if (showWall) return <>{wall}</>

  return <>{children}</>
}

export default SoftOfferPageWalledGarden
